import React from 'react';
import { Typography } from '~/UIKit';
import { EventPageInformationStyles } from './EventPageInformationDesktop.styles';
import { useEventPageInformationDesktop } from './useEventPageInformationDesktop';
import { Spots, Trainer, Location } from '~/Components/Icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const EventPageInformationDesktop = () => {
  const {
    trainerString,
    locationName,
    totalBookings,
    totalSeats,
    cancelled,
    isFreeTraining,
  } = useEventPageInformationDesktop();
  const { t } = useTranslation();

  const { classes } = EventPageInformationStyles();
  const seats = totalSeats ? `${totalBookings}/${totalSeats}` : totalBookings;

  return (
    <div className={classes.header}>
      <div className={classes.infoWrapper}>
        {!isFreeTraining && (
          <Typography className={classes.EventPageInformationTitle}>
            <Spots />
            {cancelled ? t('app.event.cancelled') : seats}
          </Typography>
        )}
        <Typography
          className={classNames(
            classes.EventPageInformationTitle,
            classes.EventPageInformationTitleText,
          )}
        >
          <Location />
          {locationName}
        </Typography>
        {!isFreeTraining && (
          <Typography
            className={classNames(
              classes.EventPageInformationTitle,
              classes.EventPageInformationTitleText,
            )}
          >
            <Trainer />
            {trainerString}
          </Typography>
        )}
      </div>
    </div>
  );
};
